export const experienceData = [
  {
    id: 1,
    company: "Mounty Outdoor Adventures Private Limited",
    jobtitle: "kotlin multiplatform Developer",
    startYear: "2021",
    endYear: "till now",
  },
  {
    id: 2,
    company: "International Schooling",
    jobtitle: "Android Developer",
    startYear: "2019",
    endYear: "2021",
  },
];
